export const GrantForm = {
    init: function() {
        this.initialized = false;
        this.isEditable = false;
        this.isRevisionEditable = false;
        this.model = {};
        this.title = "";
        this.regionId = "";
        this.files = {};
        this.revisionModel = {};
        this.status = "";

        this.isOnARevisionTab = false;
        this.hasRevision = false;
    }
};
export default GrantForm;
